import LapquestionImage from "../svg/LapAnswerImage.svg"
const SS = () => {
    return (
   
  <img src={LapquestionImage} />


    )
  }
  export default SS;